import * as React from "react";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import DownloadDocument from "src/components/common/GenericButtons/DownloadDocument/DownloadDocumentButton";

export const Documents = (props: { documentList: ITrade["documentList"] }) => {
  return (
    <div className="region-container documents">
      <span className="subtitle">Documentos</span>
      <div className="region-container">
        {props.documentList.map((doc, index) => (
          <DownloadDocument key={index} document={doc} />
        ))}
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/Documents/Documents.tsx